<script type="application/javascript">
// import allPlans from '../data/plans/allPlans.csv';

import groupBy from 'lodash/groupBy';

export default {
    props: ['allPlans'],
    data() {
        return {
            deal: null,
            plan: null,
            showBasic: true,
            checkoutOpen: false,
            contactFormCheckout: false,
            busy: false,
            featuresTable: false,
            plans: [],
            activePlan: null,
            plansType: 'yearly',
            unlimitedPlan: {
                id: 'plan_unlimited_standard_v9',
                monthly: '149',
                yearly: '1340',
                monthlyOriginal: '199', // higher price monthly
                yearlyOriginal: '165', // higher price yearly
                collaborators: 'Unlimited',
                users: 'Unlimited',
                workspaces: '1',
                storage: '100',
                AutomationRunsLimit: '10,000',
                name: 'Infinity Unlimited',
                type: 'unlimited',
                includes: [
                    'Every Feature We Have',
                    'Unlimited Users for one Fixed Price',
                    'Unlimited Boards, Items and Views',
                    '10x File and Document Storage (100GB)',
                    '10,000 Automation Runs',
                ],
                includes2: [
                    '70+ Customizable Templates',
                    'Free 1h Onboarding Setup Session',
                    'First-in-line 24/7/365 Support',
                    'Dedicated Account Manager',
                ],
            },
            unlimitedAgencyPlan: {
                id: 'plan_unlimited_agency_v9',
                monthly: '349',
                yearly: '3140',
                monthlyOriginal: '499', // higher price monthly
                yearlyOriginal: '415', // higher price yearly
                collaborators: 'Unlimited',
                users: 'Unlimited',
                workspaces: '5',
                storage: '500',
                AutomationRunsLimit: '10,000',
                name: 'White Label Agency',
                type: 'unlimited',
                includes: [
                    'Every Feature We Have',
                    '5 Workspaces for Multiple Organizations',
                    'White Label and Custom Domain',
                    'Unlimited Clients & End Users',
                    'Unlimited Boards, Items and Views',
                    '50x File and Document Storage (500GB)',
                    '50,000 Automation Runs',
                ],
                includes2: [
                    'Reseller License Included',
                    '70+ Customizable Templates',
                    'Free 1h Onboarding Setup Session',
                    'First-in-line 24/7/365 Support',
                    'Dedicated Account Manager',
                    'API & Technical Support'
                ],
            },
            infinityEcho: {
                includes: [
                    'Co-Hosted Setup and Maintenance',
                    'Full SaaS Platform (Web & Mobile)',
                    'Custom Branding, Domain, Email, Pricing',
                    'License, Admin & User Management',
                    'Single Sign-On & Integrations',
                ],
                includes2: [
                    'Custom Links, Help Center, Support',
                    'Chat/Call Support with CEO & CTO',
                    'Use-Case and Business Model Building',
                    'License Based on Workspaces and Users',
                    'Hosting Local Data in Your Country',
                ],
            },
            formSubmitted: false,
            activePlanIndex: 2
        };
    },
    mounted() {
        this.plans = groupBy(JSON.parse(this.allPlans).filter(plan => plan.group < 16), 'group');
        this.activePlan = Object.values(this.plans)[1];
        // if(this.plans) {
        //     this.activePlan = this.plans[0];
        // }
        this.$eventHub.$on('toggleOpenCheckout', function () {
            this.checkoutOpen = !this.checkoutOpen;
        }.bind(this));
        this.$eventHub.$on('toggleOpenContactFormCheckout', function () {
            this.contactFormCheckout = !this.contactFormCheckout;
        }.bind(this));
        this.$eventHub.$on('toggleFormSubmitted', function () {
            this.formSubmitted = !this.formSubmitted;
        }.bind(this));
        // this.plans = allPlans;
        // this.activePlan = this.plans[0];
    },
    watch: {
        plansType() {
            if(this.plansType == 'monthly') {
                this.plans = groupBy(JSON.parse(this.allPlans).filter(plan => plan.group < 16 && plan.group > 1), 'group');

                // Provera da li je trenutno selektovan plan sa 1 članom
                if (this.activePlan[0] && this.activePlan[0].group == 1) {
                    this.activePlan = Object.values(this.plans).find(plan => plan[0].group == 3);
                }

            } else {
                this.plans = groupBy(JSON.parse(this.allPlans).filter(plan => plan.group < 16), 'group');
            }
            this.updateActivePlanIndex();
        }
    },
    methods: {
        updateActivePlanIndex() {
            if (this.activePlan === 'unlimited') {
                this.activePlanIndex = Object.keys(this.plans).length + 1;
            } else if (this.activePlan === 'unlimitedAgency') {
                this.activePlanIndex = Object.keys(this.plans).length + 2;
            } else if (this.activePlan === 'infinityEcho') {
                this.activePlanIndex = Object.keys(this.plans).length + 3;
            } else {
                const currentPlanGroup = this.activePlan[0] && this.activePlan[0].group;
                this.activePlanIndex = Object.values(this.plans).findIndex(plan => plan[0].group === currentPlanGroup) + 1;
            }
        },
        changeActivePlan(index) {
            const numberOfPlans = Object.keys(this.plans).length;

            if (index === numberOfPlans) {
                this.activePlan = 'unlimited';
            } else if (index === numberOfPlans + 1) {
                this.activePlan = 'unlimitedAgency';
            } else if (index === numberOfPlans + 2) {
                this.activePlan = 'infinityEcho';
            } else {
                this.activePlan = Object.values(this.plans)[index];
            }
            this.updateActivePlanIndex();

            let clickedPlan;
            if(this.activePlan[0].group) {
                clickedPlan = this.activePlan[0].group;
            } else {
                clickedPlan = this.activePlan;
            }
            dataLayer.push({
                event: 'clickOnPlan',
                plan: clickedPlan,
                planType: this.plansType,
                // GA4
                section: 'Pricing'
            });

        },
        changeActivePlanDropdown(group) {
            if(group == 'unlimited') {
                this.activePlan = 'unlimited';
            } else if(group == 'unlimitedAgency') {
                this.activePlan = 'unlimitedAgency';
            }
            else if(group == 'infinityEcho') {
                this.activePlan = 'infinityEcho';
            }
            else {
                this.activePlan = this.plans[group];
            }
            // this.deal = this.plan.id;
            this.updateActivePlanIndex();

            let clickedPlan;
            if(this.activePlan[0].group) {
                clickedPlan = this.activePlan[0].group;
            } else {
                clickedPlan = this.activePlan;
            }
            dataLayer.push({
                event: 'clickOnPlan',
                plan: clickedPlan,
                // GA4
                section: 'Pricing'
            });
        },
        openCheckout(deal) {
            // this.deal = this.plan.id;
            this.deal = deal;
            this.checkoutOpen = true;
            dataLayer.push({
                event: 'clickOpenCheckout',
                plan: this.deal.id,
                planType: this.plansType,
                // GA4
                name: 'clickOpenCheckout'
            });
            if(this.deal.id == 'plan_blackfriday') {
                dataLayer.push({
                    event: 'clickOpenCheckoutBfUnlimited',
                    plan: this.deal.id,
                    planType: this.plansType
                });
            }
        },
        sendToRegister(deal) {
            let url = `http://app.startinfinity.com/register?deal=${deal.id}&price=${this.plansType}`;
            var newTab = window.open(url, '_blank');
            // Focus on the new tab
            newTab.focus();
        },
        openContactForm() {
            this.contactFormCheckout = true;
            dataLayer.push({
                event: 'clickOpenCheckout',
                plan: 'Enterprise'
            });
        },
        featuresTableToggle() {
            if(this.showBasic) {
                this.featuresTable = !this.featuresTable;
            }
            // this.showBasic = true;
        }
    },
};
</script>



// WEBPACK FOOTER //
// resources/js/frontend/components/PricingPage.vue